import React from 'react';
import { Button } from '@weirgroup/one-weir';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { ErrorMappings } from '../../shared/_constants/errorMappings.constants';
import styles from './ErrorMessage.module.css';

ErrorMessage.propTypes = {
  code: PropTypes.number,
  onClick: PropTypes.func,
};
/**
 * Common Error Message component which display title,code,message
 * @usage : <ErrorMessage code={number} onClick={()=>void}/>
 */
export default function ErrorMessage(props) {
  const { t } = useTranslation();
  /**
   * Render the error message object based on code from ErrorMappings.constant.js
   * @param  code:string
   */
  function renderErrorMessage(code) {
    const errorMappings = [...ErrorMappings];
    const index = errorMappings.findIndex((obj) => obj.code === code);
    return index > -1 ? errorMappings[index] : errorMappings[8];
  }
  const { code, onClick } = props;
  const errorObject = renderErrorMessage(code);
  return (
    <div className={styles.errorScreen} data-testid="errorScreen">
      <div className={styles.errorContainer} data-testid="errorContainer">
        <div className={styles.errorContent} data-testid="errorContent">
          <div className={styles.errorTitle}>
            {code && <span>{code} - </span>}{' '}
            <span>{t(`errorPage.${errorObject.title}`)}</span>
          </div>
          <div className={styles.errorBody}>
            {t(`errorPage.${errorObject.body}`)}
          </div>
          {errorObject.buttonText && (
            <div className={styles.errorFooter}>
              <Button
                data-testid="error-button"
                label={t(`errorPage.${errorObject.buttonText}`)}
                style={{ margin: 0 }}
                onClick={onClick}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
